export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAFl4XAc3TSwSSJFFUEtD7obTBc4PiPcQ4",
    cloudFunctionUrl:'https://us-central1-patient-f3607.cloudfunctions.net',
    authDomain: "patient-f3607.firebaseapp.com",
    projectId: "patient-f3607",
    storageBucket: "patient-f3607.appspot.com",
    messagingSenderId: "798482947447",
    appId: "1:798482947447:web:85dcab51c4f5fca6c55572",
    measurementId: "G-2ZXG3CDYNL",
  },
  //ali faizoon


  APP_ID: '218457e3fb5c9b3e',
  REGION: 'US',
  AUTH_KEY: 'c1f1942b11148741048340db858cb65bb3cd1894',

  //prev 
  // APP_ID: '195232e53135462c',
  // REGION: 'US',
  // AUTH_KEY: 'd2151ee1dd52bba300011e20769814c20c0b87f8',
};
